var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaterialSymbols(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.146L4 16.548V7.452L12 2.854L20 7.452V16.548L12 21.146ZM11.5 12.286V19.714L11.73 19.846C11.8207 19.8973 11.9107 19.923 12 19.923C12.0893 19.923 12.1793 19.8973 12.27 19.846L12.5 19.714V12.287L19 8.523V8.281C19 8.21634 18.984 8.152 18.952 8.088C18.92 8.024 18.872 7.973 18.808 7.935L18.425 7.714L12 11.427L5.575 7.714L5.192 7.934C5.128 7.97267 5.08 8.02434 5.048 8.089C5.016 8.153 5 8.21667 5 8.28V8.522L11.5 12.286Z",
    fill: "#F48000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12.286V19.714L11.73 19.846C11.8207 19.8973 11.9107 19.923 12 19.923C12.0893 19.923 12.1793 19.8973 12.27 19.846L12.5 19.714V12.287L19 8.523V8.281C19 8.21634 18.984 8.152 18.952 8.088C18.92 8.024 18.872 7.973 18.808 7.935L18.425 7.714L12 11.427L5.575 7.714L5.192 7.934C5.128 7.97267 5.08 8.02434 5.048 8.089C5.016 8.153 5 8.21667 5 8.28V8.522L11.5 12.286Z",
    fill: "#FFD2A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbols);
export default __webpack_public_path__ + "static/media/material-symbols.6fa35d14499b60ed84e4f3b0e08cea67.svg";
export { ForwardRef as ReactComponent };